export enum SetupFieldContextEnum {
  COMPANY = 'company',
  USER = 'user',
}
